import Autocomplete_ from "components/Autocomplete/Autocomplete";
import SearchInput_ from "components/SearchInput/SearchInput";
import Tooltip_ from "components/Tooltip/Tooltip";
import TooltipBody_ from "components/Tooltip/TooltipBody";
import TooltipFooter_ from "components/Tooltip/TooltipFooter";
import TooltipHeader_ from "components/Tooltip/TooltipHeader";

export const Autocomplete = Autocomplete_;
export const SearchInput = SearchInput_;
export const Tooltip = Tooltip_;
export const TooltipBody = TooltipBody_;
export const TooltipFooter = TooltipFooter_;
export const TooltipHeader = TooltipHeader_;